export default "__VITE_ASSET__5a36fcb6__"